export default __webpack_public_path__ + "static/media/empty-page.407bfed0.svg";